import React, { useEffect, useState } from "react";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";
import {
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  DropdownItem,
} from "reactstrap";
import DatePicker from "react-datepicker";
import { useForm, useController } from "react-hook-form";
import moment from "moment";
import CustomSelect from "../../../../CommonElements/CustomSelect";

const FilterForm = (props) => {
  const { register, handleSubmit, control, setValue } = useForm();

  const { field } = useController({ name: "column_name", control });

  const [date, setDate] = useState("");

  const columnsNames = props.options ? props.options : [];

  let column_type;

  switch (field.value?.type) {
    case "date":
      column_type = (
        <DatePicker
          className="form-control"
          selected={date}
          onChange={(date) => {
            setDate(date);
            setValue(
              "column_value",
              moment(new Date(date)).format("YYYY-MM-DD")
            );
          }}
          date
          showIcon
          showYearDropdown
          showMonthDropdown
          scrollableYearDropdown
          dateFormat="dd/MM/yyyy"
          shouldCloseOnSelect={true}
        />
      );
      break;
    case "text":
      column_type = (
        <input
          {...register("column_value")}
          className="form-control"
          type="text"
          placeholder="Enter Value"
        />
      );
      break;
    case "select":
      column_type = (
        <CustomSelect
          className="basic-single"
          classNamePrefix="select"
          isClearable={true}
          isSearchable={true}
          value={columnsNames.find((element) => {
            return element.value == field.value;
          })}
          onChange={(value) => {
            console.log("changed value", value);
            setValue("column_value", value.value);
          }}
          options={
            field?.value.value === "status"
              ? props.statusData
              : field?.value.value === "carTypeId"
                ? props.carTypeData
                : field?.value.value === "aggregatorId"
                  ? props.aggregatorData
                  : field?.value.value === "booking_via_type"
                    ? props.bookingViaTypeData
                    : field?.value.value === "clientType"
                      ? props.clientTypeData
                      : field?.value.value === "bookingSource"
                        ? props.bookingSourceData
                        : field?.value.value === "rideType"
                          ? props.rideTypeData
                          : []           

            // field?.value.value === "current_booking_status_type" ||
            // field?.value.value === "current_trip_status_type" ||
            // field?.value.value === "current_car_status" ||
            // field?.value.value === "procurementStatus"? props.statusData
            //   : field?.value.value === "pickup_type"
            //   ? props.pickupTypeData
            //   : field?.value.value === "carTypeId"
            //   ? props.carTypeData
            //   : field?.value.value === "aggregatorId"
            //   ? props.aggregatorData
            //   : field?.value.value === "booking_via_type" 
            //   ? props.bookingViaTypeData
            //   :props.clientTypeData
          }
        />
      );
      break;
    case "boolean":
      column_type = (
        <CustomSelect
          className="basic-single"
          classNamePrefix="select"
          isClearable={true}
          isSearchable={true}
          value={columnsNames.find((element) => {
            return element.value == field.value;
          })}
          onChange={(value) => {
            console.log("changed value", value);
            setValue("column_value", value.value);
          }}
          options={[
            { label: "True", value: true },
            { label: "False", value: false },
          ]}
        />
      );
      break;
    default:
      column_type = (
        <input
          {...register("column_value")}
          className="form-control"
          type="text"
          placeholder="Enter Value"
        />
      );
      break;
  }

  const onsubmitdata = (formValues) => {
    const filterData = props.filterData ? props.filterData : [];
    const newfilterData = [...filterData];
    const index = newfilterData.findIndex(
      (element) => element.column_name == formValues.column_name.value
    );
    if (index == -1) {
      newfilterData.push({
        key: formValues.column_name.name,
        column_name: formValues.column_name.value,
        values: [formValues.column_value],
      });
    } else {
      newfilterData[index].values = [formValues.column_value];
    }
    props.setFilterType("filter");
    props.setFilterData(newfilterData);
    props.setSearchData("");
    try {
      props.setQFName("");
      props.setQFValue("");
    } catch (err) { }

    props.toggle();
  };

  const handleSelectChange = (options) => {
    field.onChange(options?.value);
  };
  return (
    <DropdownItem
      className="border-0"
      key={"filter-data"}
      tag={"li"}
      toggle={false}
    >
      <Form onSubmit={handleSubmit(onsubmitdata)}>
        <div className="select-column">
          <CustomSelect
            className="basic-single"
            classNamePrefix="select"
            isClearable={true}
            isSearchable={true}
            value={columnsNames.find((element) => {
              return element.value == field.value;
            })}
            onChange={handleSelectChange}
            options={columnsNames}
            placeholder={"Select Category"}
          />
        </div>
        <div className="select-value">
          <FormGroup className="col-lg-12">{column_type}</FormGroup>
        </div>
        <div className="submit-filter">
          <input
            style={{ display: "none" }}
            className="form-control"
            type="submit"
            placeholder="Enter Value"
          />
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            type="submit"
            className="btn btn-primary-2"
            style={{ marginRight: "10px" }}
          >
            <i className="fa fa-check"></i>
          </button>
          <button
            type="button"
            className="btn btn-primary-2"
            onClick={() => props.toggle()}
          >
            <i className="fa fa-times"></i>
          </button>
        </div>
      </Form>
    </DropdownItem>
  );
};

export default FilterForm;
